import(/* webpackMode: "eager" */ "/work/apps/frontend/src/app/error.tsx");
